import React, {useContext, useEffect, useState} from "react";
import styles from "./processCompareFiltersDetail/ProcessCompareFiltersDetail.module.scss";
import appContext from "../../../../../context/appContext";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import http from "../../../../../services/api/utilities/http";

const ProcessCompareFiltersDetail = ({info}) => {

  const [filterData, setFilterData] = useState({});
  const [listOfSelectedVariants, setListOfSelectedVariants] = useState([]);

  const context = useContext(appContext);

  const listOfVariants = context.handleListOfVariants();

  useEffect(() => {
    if (filterData.variants) {
      setListOfSelectedVariants(listOfVariants.filter(item => filterData.variants.find(i => item.id === i)));
    }
  }, [filterData]);

  const getFilters = () => {
    http.get(`process_mining/save_process_map_state/${info.layer}`)
      .then(res => {
        setFilterData(res.data.data.process_map_config);
      })
      .catch(err => {
        console.log(err.response)
      })
  }

  useEffect(() => {
    if (info.type === "layer") {
      getFilters();
    } else {
      const filters = context?.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters
      setFilterData({
        filters: filters.filters,
        variants: filters.variants,
        view: filters.view,
        flow: filters.flow,
        metrics: filters.metrics,
      })
    }
  }, [])

  return (
    <div className={styles.ProcessCompareFiltersDetail}>
      <div>
        <p>
          These are the applied filters on the selected analysis to change them please
          select <span>"Go to Analysis"</span> option.
        </p>
      </div>
      <div className={styles.filtersWrapper}>
        <Scrollbars
          style={{height: "250px", paddingRight: 4}}
          renderView={({style, ...props}) =>
            <div {...props} style={{...style, width: "100%", height: "100%", overflowX: 'hidden'}}/>}
          renderTrackVertical={({style, ...props}) =>
            <div {...props}
                 style={{...style, right: 2, backgroundColor: '#E8EBFF', width: 1, borderRadius: 4, height: "100%"}}/>
          }
          renderThumbVertical={({style, ...props}) =>
            <div {...props} style={{
              ...style,
              backgroundColor: '#C2C7ED',
              width: 4,
              borderRadius: 4,
              cursor: "pointer",
              right: 2
            }}/>
          }
        >
          <div className={styles.variants}>
            {
              listOfSelectedVariants.length > 0 &&
              <div className={styles.title}>Variants</div>
            }
            <div>
              {
                listOfSelectedVariants.length > 0 &&
                listOfSelectedVariants.map(item => (
                  <div className={`${styles.variantWrapper}`}>
                    <span className={styles.data}>{item.id} | {item.count} | {Math.round(item.percentage)}%</span>
                    <span style={{width: `${item.percentage}%`}} className={styles.progress}></span>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={styles.dateAndTime}>
            <div className={styles.title}>Date and Time</div>
            {
              filterData.filters && filterData.filters.length > 0 && filterData.filters.map(item => (
                (item.column.includes("STARTTIME") || item.column.includes("ENDTIME") || item.column.includes("TIMESTAMP")) &&
                <div className={styles.dateAndTimeWrapper}>
                  <div>
                    <div className={styles.title}>{item.column[0]}</div>
                    <div className={styles.data}>
                      {/*<span>{ moment(item.value[0].split(",")[0]).format("DD MMM YYYY") }</span>*/}
                      <span>
                                                    {
                                                      item.value ? item.value.map(i => i.split(",").map(item => moment(item).format("DD MMM YYYY")).join(" - ")) : null
                                                    }
                                                </span>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>

          <div className={styles.caseAttributes}>
            <div className={styles.title}>Case Attributes</div>
            {
              filterData.filters && filterData.filters.length > 0 && filterData.filters.map(item => (
                (!(item.column.includes("STARTTIME") || item.column.includes("ENDTIME"))) &&
                <div className={styles.caseAttributesWrapper}>
                  <div className={styles.title}>{item.column[0]}</div>
                  <div className={styles.title}>{item.operand[0]}</div>
                  {item.operand.map((i, index) => (
                    <div className={"mt-1 mb-1"}>
                      {/*<div className={styles.title}>{item.column} {i} </div>*/}
                      <div className={styles.data}>{item.value[index]}</div>
                    </div>
                  ))}
                </div>
              ))
            }
          </div>
          <div className={styles.flowSelection}>
            <div className={styles.title}>Flow Selection</div>
            {
              filterData?.flow?.length ? filterData.flow.map(item => (
                <div className={styles.flowSelectionWrapper}>
                  {
                    item.seq.map((i, index) => (
                      <div className={`${styles.data} mt-1 mb-1`}>{i.activity_name}</div>
                  ))
                  }
                </div>
              )) : null
            }
          </div>
          <div className={styles.metrics}>
            <div className={styles.title}>Metrics</div>
            {
              filterData?.metrics?.length && filterData.metrics.map(item => (
                <div className={styles.metricsWrapper}>
                  <div className={styles.title}>{item.column}</div>
                  <div className={styles.data}>{item.operand}</div>
                  <div className={styles.data}>{item.value}</div>
                </div>
              ))
            }
          </div>
        </Scrollbars>
      </div>
    </div>
  )
};

export default ProcessCompareFiltersDetail;